import { PublicClientApplication , InteractionRequiredAuthError} from '@azure/msal-browser';
import { msalConfig,loginRequest } from './authConfig';
import { RHYBUS_ACCESS_TOKEN, RHYBUS_REFRESH_TOKEN, USER_LOGIN_SESSIONID, authType } from './Configuration'
import { anewUserLoginHttp } from './shared/services/api/anew-user-loginotp';
import { generateGUID } from './shared/utils/globalFunctions';
import { keycloakIsTokenExpired, keycloakLogout, keycloakGenerateSilentTokenIfExpired } from './authKeycloak';
//import { createBrowserHistory } from "history";

export const msalInstance = new PublicClientApplication(msalConfig);

//const history = createBrowserHistory();

  const isTokenExpired = async (): Promise<boolean> => {
    if (authType.toLowerCase() === 'keycloak') return keycloakIsTokenExpired();
    await msalInstance.initialize();
        const accounts:any = msalInstance.getAllAccounts();  
        if (accounts.length === 0) {
          return true; // No account found, so consider the token expired
        }
        if (!accounts[0].idToken) {
          return true; // No ID token available, consider expired
        }
        const expirationTime = accounts[0].idTokenClaims.exp * 1000;
        return Date.now() > expirationTime; // Check if current time is greater than the expiration time
    };

    const isOTPTokenExpired = async (): Promise<boolean> => {
      const otpToken = localStorage.getItem(RHYBUS_ACCESS_TOKEN);
      if (!otpToken) {
        return true;
      }
      
      try {
        // Validate JWT format (3 parts separated by dots)
        const parts = otpToken.split('.');
        if (parts.length !== 3) {
          console.error("Invalid token format");
          return true;
        }
        
        const tokenPayload = JSON.parse(atob(parts[1]));
        if (!tokenPayload.exp) {
          return true;
        }
        
        const now = Math.floor(Date.now() / 1000);
        const bufferTime = 10 * 60; // 10min buffer
        return tokenPayload.exp <= (now + bufferTime);
      } catch (error) {
        console.error("Invalid OTP token:", error);
        return true;
      }
    };

  const logoutIfExpired = async () => {
    if (authType.toLowerCase() === 'keycloak') return keycloakLogout();
    await msalInstance.initialize();
      if (await isTokenExpired()) {
        msalInstance.logoutRedirect().then(() => {
            console.log("Logged out due to token expiration.");
          }).catch((error) => {
            console.error("Logout error", error);
          });
        }  
    };

    const logoutIfInactive = async () => {
        localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
        localStorage.setItem(RHYBUS_REFRESH_TOKEN, '');
        localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
        localStorage.removeItem(RHYBUS_REFRESH_TOKEN) ;
        window.location.href='/signout';     
  };
  
  export const logoutUserIfInactive = (navigate: (path: string) => void) => {
    localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
    localStorage.setItem(RHYBUS_REFRESH_TOKEN, '');
    localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
    localStorage.removeItem(RHYBUS_REFRESH_TOKEN);

    navigate('/signout');
};

  const logoutUserIfExpired = async () => {
      if (authType.toLowerCase() === 'keycloak') return keycloakLogout();
      await msalInstance.initialize();
          msalInstance.logoutRedirect().then(() => {
              console.log("Logged out due to token expiration.");
            }).catch((error) => {
              console.error("Logout error", error);
            });          
  };

  const refreshPageIfExpired = async () => {
      window.location.reload();     
    };

  const generateSilentTokenIfExpired = async () => {
      if (authType.toLowerCase() === 'keycloak') return keycloakGenerateSilentTokenIfExpired();
      await msalInstance.initialize();
      const accounts:any = msalInstance.getAllAccounts();  
          if (accounts.length === 0) return;
          const request:any = {
          ...loginRequest,
          account: accounts[0],
          };
          try {
          const response:any = await msalInstance.acquireTokenSilent(request);
          localStorage.setItem(USER_LOGIN_SESSIONID,generateGUID()??'');
          localStorage.setItem(RHYBUS_ACCESS_TOKEN,'')
          localStorage.setItem(RHYBUS_ACCESS_TOKEN,response.accessToken);
          } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
              try {
              const response:any = await msalInstance.acquireTokenRedirect(request);
              localStorage.setItem(RHYBUS_ACCESS_TOKEN,response.accessToken);
              } catch (popupError) {
              console.error('Token acquisition failed', popupError);
              }
          } else {
              console.error('Token acquisition failed', error);
          }
          }   
    };

  const getRefreshTokenIfOtpLoginTokenExpires = async () => {
      try {
        localStorage.removeItem(USER_LOGIN_SESSIONID);
        localStorage.setItem(USER_LOGIN_SESSIONID,generateGUID()??'');
        const refreshToken = localStorage.getItem(RHYBUS_REFRESH_TOKEN);
        if (!refreshToken) {
          throw new Error("No refresh token found");

        }
        const response: any = await anewUserLoginHttp().RefreshAccessToken(refreshToken);
        if (response && response.accessToken) {
        localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken);
        localStorage.setItem(RHYBUS_REFRESH_TOKEN, response.refreshToken);
        }
      } catch (error: any) {
        if (error?.status === 401 || error?.status === 403) {
          localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
          showLogoutPopup("Session Expired", "Your session has expired. Please log in again.");
        }
        console.log("OTP Token refresh failed:", error);
      } 
  };


 export function showLogoutPopup(header: string, message: string) {
  const pageOverlay = document.getElementById("pageoverlay");
  if (pageOverlay) {
    pageOverlay.style.display = "none";
  }
  if (document.querySelector(".token-expiry-popup-overlay")) return;

  const overlay = document.createElement("div");
  overlay.className = "token-expiry-popup-overlay";

  const popup = document.createElement("div");
  popup.className = "token-expiry-popup";

  popup.innerHTML = `
    <h2 tabIndex="0" aria-label="Unable To Access" class="mb-2">${header}</h2>
    <p tabIndex="0" aria-label= ${message}>
      ${message}
    </p>
    <button id="popup-logout-btn">Okay</button>
  `;

  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  document
    .getElementById("popup-logout-btn")!
    .addEventListener("click", () => {
    const overlay = document.querySelector(".token-expiry-popup-overlay");
      if(overlay){
      overlay?.remove?.();
    handleLogout()
  }
    });
}


export function handleLogout() {
  localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
  localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
  localStorage.removeItem(USER_LOGIN_SESSIONID);
  if (authType.toLowerCase() === 'keycloak') {
    keycloakLogout().catch((error) => console.error('Logout error', error));
    return;
  }
  window.dispatchEvent(new Event("app-logout"));
}

  export { 
          logoutIfExpired,isTokenExpired,logoutUserIfExpired,
          refreshPageIfExpired,generateSilentTokenIfExpired,
          getRefreshTokenIfOtpLoginTokenExpires,isOTPTokenExpired,
          logoutIfInactive
    };

